import { quoteLinkApiClient } from 'config/quoteLinkApi';

export const fetchTemplateCode = (quoteId, templateNames) => {
  // Build a comma separated string of template names
  const templateNamesString = templateNames.join(',');
  return quoteLinkApiClient.get(
    `/api/renderquote?quoteId=${quoteId}&content=${templateNamesString}`,
  );
};

export const getAssigneeId = (quoteId, accessToken) =>
  quoteLinkApiClient.get(
    `/api/external/quotes?token=${accessToken}&_id=${quoteId}`,
  );

export const contactAgent = (payload, accessToken) => {
  return quoteLinkApiClient.post(
    `/api/external/events?token=${accessToken}`,
    payload,
  );
};

export const fetchContentData = (queryString) => {
  return quoteLinkApiClient.get(
    `/api/v1.10/content/query?query=${queryString}`,
  );
};

export const getQuote404Message = () =>
  quoteLinkApiClient.get(`/api/fs/gridfs/404.txt`);
